export default __webpack_public_path__ + "static/6911-82a513e5c218c27e53c694bce9bed613.jpg";